// frontend/src/site/editor/PreviewFrame.jsx
import React, { useMemo, useState } from 'react';
import SiteRendererPure from '../renderer/SiteRendererPure';
import { themeToVars } from '../theme/getSiteTheme';

function clamp(v, min, max) {
  const n = Number(v);
  if (!Number.isFinite(n)) return min;
  return Math.max(min, Math.min(max, n));
}

export default function PreviewFrame({
  modelId = 'corretor',
  handle = 'preview',
  theme = null,
  estrutura = [],
  conteudo = {},
  perfilSite = null,
  ownerWhatsUrl = '',
}) {
  const [viewport, setViewport] = useState('desktop'); // desktop | mobile
  const width = viewport === 'mobile' ? 420 : 1200;

  // ✅ fallback pra não quebrar quando theme ainda não carregou
  const safeTheme = theme || { mode: 'light' };

  // ✅ key baseada em campos (independe de referência do objeto)
  // Isso blinda o preview mesmo se o theme vier "mutado" de fora.
  const themeKey = useMemo(() => {
    const t = safeTheme || {};
    return [
      t.mode,
      t.modelId,
      t.styleId,
      t.paletteId,
      t.preset,
      t.layoutDensity,
      t.buttonStyle,
      t.cardStyle,
    ]
      .filter(Boolean)
      .join('|');
  }, [
    safeTheme?.mode,
    safeTheme?.modelId,
    safeTheme?.styleId,
    safeTheme?.paletteId,
    safeTheme?.preset,
    safeTheme?.layoutDensity,
    safeTheme?.buttonStyle,
    safeTheme?.cardStyle,
  ]);

  // ✅ vars do tema recalculam por "themeKey"
  const vars = useMemo(() => themeToVars(safeTheme), [themeKey]);

  return (
    <div className="rounded-2xl border border-gray-200 bg-white overflow-hidden">
      {/* Toolbar */}
      <div className="flex items-center justify-between gap-3 px-3 py-2 border-b border-gray-200 bg-gray-50">
        <div className="text-sm font-medium text-gray-900">Preview</div>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => setViewport('desktop')}
            className={`px-3 py-1.5 rounded-lg text-sm border ${
              viewport === 'desktop'
                ? 'border-black bg-white text-gray-900'
                : 'border-gray-200 bg-white text-gray-700 hover:bg-gray-50'
            }`}
          >
            Desktop
          </button>
          <button
            type="button"
            onClick={() => setViewport('mobile')}
            className={`px-3 py-1.5 rounded-lg text-sm border ${
              viewport === 'mobile'
                ? 'border-black bg-white text-gray-900'
                : 'border-gray-200 bg-white text-gray-700 hover:bg-gray-50'
            }`}
          >
            Mobile
          </button>
        </div>
      </div>

      {/* Canvas */}
      <div className="bg-gray-100 p-3">
        <div className="mx-auto">
          <div
            className="mx-auto bg-white rounded-xl shadow-sm overflow-hidden"
            style={{
              width: `${clamp(width, 320, 1400)}px`,
              maxWidth: '100%',
            }}
          >
            {/* aplica vars do tema dentro do preview */}
            <div
              data-theme={safeTheme?.mode || 'light'}
              style={vars}
              className="min-h-[70vh]"
            >
              <SiteRendererPure
                key={themeKey} // ✅ garante re-render quando tema mudar
                model={modelId}
                handle={handle}
                theme={safeTheme}
                estrutura={estrutura}
                conteudo={conteudo}
                perfilSite={perfilSite}
                ownerWhatsUrl={ownerWhatsUrl}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
